import BfdUtil from '@baifendian/adherev-util';
import Resource from './resource';
var withVue = BfdUtil._util.withVue;
Resource.install = function (app) {
    withVue(app, 'Resource', Resource);
    return app;
};
export default Resource;
